import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils/cn";

export function Spinner({ className, label = "Cargando" }: { className?: string; label?: string }) {
  return (
    <span role="status" className="inline-flex items-center gap-2">
      <Loader2 className={cn("h-5 w-5 animate-spin text-brand-700", className)} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export function FullPageSpinner({ label = "Cargando" }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[50vh] w-full items-center justify-center">
      <Spinner label={label} className="h-8 w-8" />
    </div>
  );
}
